module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av475-3bf6a8f06c9e98ac1f33a3aa15fe03f0.jpg";